module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A text-input with an icon button inside</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n  <TextInputWithIcon label        = \"Enter a URL\"\n                     iconType     = \"preview\"\n                     iconPosition = \"left\"\n                     textAlign    = \"left\" />\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/TextInputWithIcon/README.md
// module id = 407
// module chunks = 0